export * from './files.reducer';

export type {IFilesStoreState} from './IFilesStoreState';
